export const PROFILE_COMPLETE_CELEBRATION_KEY = 'profileCompleteCelebration';
export const PROFILE_COMPLETE_CELEBRATION_DISMISSED_KEY = 'profileCompleteCelebrationDismissed';
export const PROFILE_COMPLETE_CELEBRATION_LEAVE_PENDING_KEY = 'profileCompleteCelebrationLeavePending';
export const PROFILE_COMPLETE_CELEBRATION_HANDOFF_KEY = 'profileCompleteCelebrationHandoff';
export const PROFILE_COMPLETE_CELEBRATION_LANDING_KEY = 'profileCompleteCelebrationLanding';
export const PROFILE_COMPLETE_FLOW_ORIGIN_KEY = 'profileCompleteFlowOrigin';
export const PROFILE_COMPLETE_FROM_PARAM = 'profile-complete';
export const PROFILE_COMPLETE_EDIT_PET_PARAM = 'editPet';
export const PROFILE_COMPLETE_NO_PET_SELECTED_KEY = 'profileCompleteNoPetSelected';
export const PROFILE_COMPLETE_NOTIFICATIONS_SUBMITTED_KEY = 'profileCompleteNotificationsSubmitted';
export const PROFILE_COMPLETE_FLOW_PET_KEY = 'profileCompleteFlowPet';
export const PROFILE_COMPLETE_FLOW_USER_SCOPE_KEY = 'profileCompleteFlowUserScope';

export const COMPLETE_PROFILE_ROUTE = '/account/complete-profile';

export const TOTAL_PROFILE_COMPLETION_STEPS = 3;

export type ProfileCompletionStepId = 'pet' | 'address' | 'notifications';

export type ProfileCompletionReturnTo = 'treats' | 'about-you';

export const PROFILE_COMPLETION_STEP_ORDER: ProfileCompletionStepId[] = ['pet', 'address', 'notifications'];

export const PROFILE_COMPLETION_STEP_LABELS: Record<ProfileCompletionStepId, string> = {
    pet: 'Add a pet',
    address: 'Add an address',
    notifications: 'Opt-in to notifications',
};

export const PROFILE_COMPLETION_STEPPER_LABELS: Record<ProfileCompletionStepId, string> = {
    pet: 'Pet',
    address: 'Address',
    notifications: 'Opt-in',
};

export type CompleteProfileStepperView = ProfileCompletionStepId | 'confirmation';
